import React, { Component } from 'react';
import './view.css';
import { connect } from 'react-redux';

import TabControl from '../TabControl/tabControl';
import ToolStrip from '../ToolStrip/toolStrip';
import Label from '../Label/label';
import TextBox from '../TextBox/textbox';
import Button from '../Button/button';
import GroupBox from '../GroupBox/groupbox';
import FormLine from '../FormLine/formline';
import CheckBox from '../CheckBox/checkbox';
import RadioList from '../RadioList/radiolist';
import ListView from '../ListView/listview';
import PictureBox from '../PictureBox/picturebox';
import ComboBox from '../ComboBox/combobox';

//import NBTable from "";

// TODO
/*
- ADD Tabulation capabilities
- Change ViewMode



*/

class View extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
      this.state = {
        isEdit:false,
        viewName:"This is the view Name",
        viewMode:"Custom",
        labelConfig:{color:"#aad",text:"Sample Label", additionalClass:"",textAlign:"right"},
        listviewConfig:{id:"Id",isSelectable:true,columns:[{name:"Col1",type:"text"},{name:"Col2",type:"number"}],actions:["Update","Delete"]},
        checkboxConfig:{color:"#aad",text:"Sample Checkbox"},
        buttonConfig:{isEnabled:true,icon:"check",text:"save change",color:"#0d0",textAlign:"center",bgcolor:""},
        textBoxConfig:{mask:"99/99/9999", color:"#aad",readOnly:false, maxLength:20, textAlign:"left"},
        radioConfig:{name:"This is the label of the radio list",color:"", options:[
          {name:"Choice 1",value:"1",isEnabled:true, isSelected:true},
          {name:"Choice 2",value:"2",isEnabled:false, isSelected:false},
          {name:"Choice 3",value:"3",isEnabled:true, isSelected:false},
          {name:"Choice 4",value:"4",isEnabled:true, isSelected:false},
          {name:"Choice 5",value:"5",isEnabled:true, isSelected:false},
        ]},
        tabConfig:[
          {name:"Program", isEnable:true, show:"show", icon:"list", content:"Program Content"},
          {name:"TestTab2", isEnable:true, show:"show", icon:"table", content:"TestTab2 Content"},
          {name:"TestTab3", isEnable:false, show:"show", icon:"pen", content:"TestTab3 Content"},
          {name:"TestTab4", isEnable:true, show:"show", icon:"trash", content:"TestTab4 Content"},
        ],
        toolstripConfig: [
          {name:"Add",isEnable:true, show:"show", icon:"plus", endPoint:"EN3ECLoad"},
          {name:"Update",isEnable:true, show:"show", icon:"pen", endPoint:"EN3ECLoad"},
          {name:"Delete",isEnable:true, show:"show", icon:"trash", endPoint:"EN3ECLoad"},
          {name:"Refresh",isEnable:false, show:"show", icon:"sync-alt", endPoint:"EN3ECLoad"},
          {name:"Valid",isEnable:true, show:"show", icon:"check", endPoint:"EN3ECLoad"},
          {name:"Cancel",isEnable:true, show:"show", icon:"times", endPoint:"EN3ECLoad"},
        ],
        data : {
          columns:[
            {name:"Column Name 1",type:"text",sort:0,size:"s"},
            {name:"Column Name 2",type:"number",sort:1,size:"s"},
            {name:"Column Name 3",type:"text",sort:0,size:"xl"},
            {name:"Column Name 4",type:"devise",sort:0,size:"xs"},
            {name:"Column Name 5",type:"text",sort:0,size:"l"},
          ],
          data:[
            ["small text1",123,"Comment and long text comming here9","EUR","Normal text9"],
            ["small text2",12345,"Comment and long text comming here5","EUR","Normal text8"],
            ["small text3",12367,"Comment and long text comming here6","EUR","Normal text7"],
            ["small text4",12389,"Comment and long text comming here2","EUR","Normal text6"],
            ["small text5",12310,"Comment and long text comming here2","EUR","Normal text5"],
            ["small text6",1231234567,"Comment and long text comming here1","EUR","Normal text4"],
            ["small text7",123,"Comment and long text comming here9","EUR","Normal text3"],
            ["small text8",123,"Comment and long text comming here5","EUR","Normal text2"],
            ["small text9",123,"Comment and long text comming here2","EUR","Normal text1"],
            ["small text10",123,"Comment and long text comming here2","EUR","Normal text0"],
            ["small text11",123,"Comment and long text comming here3","EUR","Normal text01"],
            ["small text12",123,"Comment and long text comming here1","EUR","Normal text02"],
            ["small text13456789465789 465432 fsdgoihze jbzkejb ",123,"Comment and long text comming here1","EUR","Normal text03"],
          ]
        },
      };

    }



    /* 
    CUSTOMIZE RETURN
    */
    updateConfigTAB = (e) =>{
      this.setState({tabConfig:JSON.parse(e)});
    }
    updateConfigToolStrip = (e) =>{
      this.setState({toolstripConfig:JSON.parse(e)});
    }
    updateConfigLabel = (e) =>{
      this.setState({labelConfig:JSON.parse(e)});
    }

    updateConfigTextBox = (e) =>{
      this.setState({textBoxConfig:JSON.parse(e)});
    }

    updateConfigButton = (e) =>{
      this.setState({buttonConfig:JSON.parse(e)});
    }

    onUpdateValue = (id,e) =>{
      console.log(" TODO updateValue",id,e);
    }

    onUpdateCheckBox = (id,e)=>{
      console.log("TODO updateValue",id,e);
    }
    onUpdateRadio = (id,e)=>{
      console.log("TODO updateValue",id,e);
    }
    onSelectListItem = (ids)=>{
      console.log("TODO update select Listitem",ids);
    }

    // COMPONENT RETURN CALLBACK
    onClickedToolStrip = (itemClicked,relatedObject) =>{
      // GET NAME
      var action = itemClicked.name;
      
    }

    onClickButton = () =>{
      console.log("TODO ckick!");
      
    }

    
  
    render() {

      // var viewName = this.state.viewName;
      // var viewActions = this.buildActionsPannel();
      // var viewContent = null;
      // switch (this.state.viewMode) {
      //   case "Edit":
      //     viewContent = this.buildEditContent(this);
      //     break;
      //   case "Table" :
      //     viewContent = this.buildTableContent(this);
      //     break;
      //   case "Graph": 
      //   viewContent = this.buildGraphContent(this);
      //     break;
      //   case "Custom": 
      //     viewContent = this.buildDefaultContent(this);
      //       break;
      //   default:
      //     viewContent = this.buildDefaultContent(this);
      //     break;
      // }
      var item={
        FLAG:null,
        ObjDataDto:null,
        ObjDatasCibleDto:null,
        ObjDatasSourceDto:null,
        ObjParamDto:null,
        ObjParamsDto:{
            ARCS_PER:0,
            ARCS_TP_N3:0,
            CD:null,
            CODE:null,
            DestroyCol:0,
            LNH:null,
            RecordFlag:null,
            SV:0,
            SessionIDE:this.props.sessionId,
            ToIUD:0
        },
        Session:{
            Application:null,
            CodeApplication:4,
            Session:null
        },
        objFile:null,
        vntIndexKey:0
    };

      return (
        <div className="view-container" >
          <div className="component">
            <TabControl config={this.state.tabConfig} />
            <div className="info">
              <span>TAB Component Test Config (in JSON)</span>
              <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigTAB.bind(this)}/>
              <span>Config object</span><br/>
              <code>
                {'['}<br/>
                {'{"name":"Program", "isEnable":true, "show":"show", "icon":"list", "content":"Program Content"},'}<br/>
                {'{"name":"TestTab2", "isEnable":true, "show":"show", "icon":"table", "content":"TestTab2 Content"},'}<br/>
                {'{"name":"TestTab3", "isEnable":false, "show":"show", "icon":"pen", "content":"TestTab3 Content"},'}<br/>
                {'{"name":"TestTab4", "isEnable":true, "show":"show", "icon":"trash", "content":"TestTab4 Content"}'}<br/>
                {'];'}
              </code><br/>
            </div> 
          </div> 
          <div className="component">
            <div className="itemLine">
              <span>
                <ToolStrip preventMultipleClick={1000} object={item} config={this.state.toolstripConfig} OnClickElement={this.onClickedToolStrip.bind()}/>
              </span>
                <div className="info">
                  <span>ToolStrip Component Test Config (in JSON)</span>
                  <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigToolStrip.bind(this)}/>
                  <span>Config object</span><br/>
                  <code>
                    {'[ '}<br/>
                    {'{"name":"Add","isEnable":true, "show":"show", "icon":"plus", "endPoint":"EN3ECLoad"},'}<br/>
                    {'{"name":"Update","isEnable":true, "show":"show", "icon":"pen", "endPoint":"EN3ECLoad"},'}<br/>
                    {'{"name":"Delete","isEnable":true, "show":"show", "icon":"trash", "endPoint":"EN3ECLoad"},'}<br/>
                    {'{"name":"Refresh","isEnable":false, "show":"show", "icon":"sync-alt", "endPoint":"EN3ECLoad"},'}<br/>
                    {'{"name":"Valid","isEnable":true, "show":"show", "icon":"check", "endPoint":"EN3ECLoad"},'}<br/>
                    {'{"name":"Cancel","isEnable":true, "show":"show", "icon":"times", "endPoint":"EN3ECLoad"}'}<br/>
                    {'];'}
                  </code><br/>
              </div>
            </div>
          </div>
          <div className="component">
              <span className="element">
                <Label config={this.state.labelConfig}/>
              </span>
              <div className="info">
                  <span>Label Component Test Config (in JSON)</span>
                  <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigLabel.bind(this)}/>
                  <span>Config object</span><br/>
                  <code>
                    {'{"color":"#aad","text":"Sample Label", "additionalClass":"tagged", "icon":"list"}'}<br/>
                  </code><br/>
            </div>
          </div>
          <div className="component">
              <span className="element">
                <TextBox config={this.state.textBoxConfig} updateValue={this.onUpdateValue.bind(this,1)}/>
              </span>
              <div className="info">
                  <span>TextBox Component Test Config (in JSON)</span>
                  <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigTextBox.bind(this)}/>
                  <span>Config object</span><br/>
                  <code>
                    {'{"color":"#aad","readOnly":false, "maxLength":20, "textAlign":"left"}'}<br/>

                  </code><br/>
                
              </div>
            </div>
          <div className="component">
            <span className="element">
              <Button preventMultipleClick={1000} config={this.state.buttonConfig} OnClickElement={this.onClickButton.bind(this)}/>
              <Button config={{isEnabled:false,icon:"pen",text:"edit item",color:"",textAlign:"left",bgcolor:""}} OnClickElement={this.onClickButton.bind(this)}/>
              <Button config={{isEnabled:true,icon:"trash",text:"delete change",color:"",textAlign:"right",bgcolor:"#c33"}} OnClickElement={this.onClickButton.bind(this)}/>
            </span>
            <div className="info">
                <span>Button Component Test Config (in JSON)</span>
                <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigButton.bind(this)}/>
                <span>Config object</span><br/>
                <code>
                  {'{isEnabled:false,icon:"check",text:"save change",color:"#0d0",textAlign:"center",bgcolor:""}'}<br/>

                </code><br/>
              
            </div>
          </div>
          <div className="component">
            <span className="element">
              <GroupBox name="GroupBox1">
                <FormLine>
                  <Label config={this.state.labelConfig}/>
                  <ToolStrip preventMultipleClick={1000} object={item} config={this.state.toolstripConfig} OnClickElement={this.onClickedToolStrip.bind()}/>
                </FormLine>
                
                <GroupBox name="Docked GroupBox 2">
                  <FormLine>
                    <Label config={this.state.labelConfig}/>
                    <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.onUpdateValue.bind(this,1)}/>
                    <ToolStrip preventMultipleClick={1000} object={item} config={this.state.toolstripConfig} OnClickElement={this.onClickedToolStrip.bind()}/>
                  </FormLine>
                  <FormLine>
                    <CheckBox config={this.state.checkboxConfig} updateChange={this.onUpdateCheckBox.bind(this,item)}/>
                    <CheckBox config={this.state.checkboxConfig} updateChange={this.onUpdateCheckBox.bind(this,item)}/>
                  </FormLine>
                  <FormLine>
                    <TabControl config={this.state.tabConfig} /> 
                    
                  </FormLine>
                  <Button preventMultipleClick={1000} config={this.state.buttonConfig} OnClickElement={this.onClickButton.bind(this)}/>
                </GroupBox>
                <Button preventMultipleClick={1000} config={this.state.buttonConfig} OnClickElement={this.onClickButton.bind(this)}/>
              </GroupBox>
            </span>
            <div className="info">
                <span>GroupBox Component Test Config (in JSON)</span>
                <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigButton.bind(this)}/>
                <span>Config object</span><br/>
                <code>
                  {/* {'{isEnabled:false,icon:"check",text:"save change",color:"#0d0",textAlign:"center",bgcolor:""}'}<br/> */}

                </code><br/>
              
            </div>
          </div>
          <div className="component">
              <span className="element">
                <CheckBox config={this.state.checkboxConfig} updateChange={this.onUpdateCheckBox.bind(this,item)}/>
                <CheckBox config={this.state.checkboxConfig} updateChange={this.onUpdateCheckBox.bind(this,item)}/>
                <CheckBox config={this.state.checkboxConfig} updateChange={this.onUpdateCheckBox.bind(this,item)}/>
                <CheckBox config={this.state.checkboxConfig} updateChange={this.onUpdateCheckBox.bind(this,item)}/>
              </span>
              <div className="info">
                  <span>CheckBox Component Test Config (in JSON)</span>
                  <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigLabel.bind(this)}/>
                  <span>Config object</span><br/>
                  <code>
                    {'{color:"#aad",text:"Sample Checkbox"}'}<br/>
                  </code><br/>
            </div>
          </div>
          <div className="component">
              <span className="element">
                <ComboBox onSelectItem={this.onSelectListItem.bind()} config={this.state.listviewConfig} listItem={[{Id:0,Col1:"Value1",Col2:"OtherValue"},{Id:1,Col1:"Value145",Col2:"Value22"},{Id:2,Col1:"Valu32",Col2:"Value154"},{Id:3,Col1:"Value3",Col2:"Value4"}]} />  
              </span>
              <div className="info">
                  <span>ComboBox Component Test Config (in JSON)</span>
                  
            </div>
          </div>
          <div className="component">
              <span className="element">
                <RadioList config={this.state.radioConfig} updateChange={this.onUpdateRadio.bind(this,item)}/>
              </span>
              <div className="info">
                  <span>RadioList Component Test Config (in JSON)</span>
                  <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigLabel.bind(this)}/>
                  <span>Config object</span><br/>
                  <code>
                    {''}<br/>
                  </code><br/>
            </div>
          </div>
          <div className="component">
              <span className="element">
                {/* <ListView onSelectItem={this.onSelectListItem.bind()} config={this.state.listviewConfig} listItem={[{Id:0,Col1:"Value1",Col2:"OtherValue"},{Id:1,Col1:"Value145",Col2:"Value22"},{Id:2,Col1:"Valu32",Col2:"Value154"},{Id:3,Col1:"Value3",Col2:"Value4"}]} /> */}
              </span>
              
          </div>
          <div className="component">
              <span className="element">
                <PictureBox config={{width:'100px', height:'150px'}}/>  
              </span>
              <div className="info">
                  <span>ListView Component Test Config (in JSON)</span>
                  <TextBox config={{color:"#aad",readOnly:false, maxLength:0, textAlign:"left"}} updateValue={this.updateConfigLabel.bind(this)}/>
                  <span>Config object</span><br/>
                  <code>
                    {''}<br/>
                  </code><br/>
            </div>
          </div>
          
          {/* <div className="view-header">
            <div className="view-title">{viewName}</div>
            <div className="view-actions">
              {viewActions}
            </div>
          </div>
          {viewContent} */}
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      isAdmin : state.appReducer.isAdmin,
      sessionId: state.apiReducer.sessionId,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(View);
  

  
    // changeViewMode = (mode) =>{
    //   this.setState({viewMode:mode});
    // }

    // buildActionsPannel = () =>{
    //     return [
    //       <div key='0' className={this.state.viewMode === "Custom"? "view-action active" :"view-action"} onClick={this.changeViewMode.bind(this,"Custom")}>
    //         <span>Tab Name</span>
    //       </div>,
    //       <div key='1' className={this.state.viewMode === "Edit"? "view-action active" :"view-action"} onClick={this.changeViewMode.bind(this,"Edit")}>
    //         <FontAwesomeIcon  icon="pen" />
    //       </div>,
    //       <div key='2' className={this.state.viewMode === "Table"? "view-action active" :"view-action"} onClick={this.changeViewMode.bind(this,"Table")}>
    //         <FontAwesomeIcon  icon="table" />
    //     </div>,
    //     <div key='3' className={this.state.viewMode === "Graph"? "view-action active" :"view-action"} onClick={this.changeViewMode.bind(this,"Graph")}>
    //         <FontAwesomeIcon  icon="chart-pie" />
    //     </div>,
    //     ]
    // }

    // buildEditContent =()=>{
    //   var content=<Form></Form>;
    //   return (
    //     <div className="view-content">
    //       {content}
    //       <Form></Form>
    //       <Form></Form>
    //       <Form></Form>
    //     </div>
    //   )
    // }

    // updateColumnSortingByIndex =(i) =>{
    //   var _data = {...this.state.data};
    //   var _i = i;
    //   _data.columns.forEach((column,key) => {
    //     if(key ===_i){
    //       if(column.sort === 1){
    //         column.sort = 2;
    //       }else{
    //         column.sort = 1;
    //       }
    //     }else{
    //       column.sort =0;
    //     }
        
    //   });
    //   this.setState({data:_data});
    // }

    // buildTableContent =()=>{
    //   var content="Table content";
    //   return (
    //     <div className="view-content">
    //       <Table data={this.state.data} onUpdateColumnSorting={this.updateColumnSortingByIndex.bind(this)}></Table>
    //     </div>
    //   )
    // }
    
    // buildGraphContent =()=>{
    //   var colorPie = ['#00188f','#009e49','#68217a','#bad80a','#00b294','#e81123','#00bcf2','#fff100','#ec008c', '#ff8c00'];
    //   var pieOption = { 
    //     colors: colorPie,
    //     labels: ["val1","val2","val3","val4"],
    //   }
    //   var content=(
    //   <div className="chart">
    //     <div className="chart-name">
    //       Chart Name
    //     </div>
    //     <Chart
    //         options={pieOption}
    //         series={[200,150,26,37]}
    //         type="pie"
    //         width="500"
    //     />
    //   </div>
    //   );
    //   return (
    //     <div className="view-content">
    //       {content}
    //     </div>
    //   )
    // }


    // buildViewContent = () =>{
      
    // }

    // buildDefaultContent = () =>{
    //   var content="Custom content";
    //   return (
    //     <div className="view-content">
    //       <Program></Program>
    //     </div>
    //   )
    // }
